import type { FaireProductEntity } from "../../entity_types/product";

export const p_4f8gsnmdpn: FaireProductEntity = {
  token: "p_4f8gsnmdpn",
  type: "product",
  name: "Bridget Sweater - Grove (Faire Pre-Order)",
  brandToken: "b_9ut9ansxk1",
  brandName: "The Endery",
  imageUrl: "https://cdn.faire.com/fastly/a06d9053d794829c271169eee6506f11d497dae690e3e5eeedb41cdfe1aa651f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7ef2f4fed2cb621f6f56831ecc6e0c20f14e1541fc317caec30489a8b96b98e0.jpeg",
    "https://cdn.faire.com/fastly/08b0586c014ea66ef963bf59adc498d77d7516e9f6be6353e9b780df472dda54.jpeg",
    "https://cdn.faire.com/fastly/9f0ff13611d7930af23477ded06ad6c66c57ca2bf7c654ffd73ffa716daa3f23.jpeg",
    "https://cdn.faire.com/fastly/fc356cecf20c33205f0a3bf36509dc170670364d9cd564682a5ad5f94d8b0280.jpeg",
    "https://cdn.faire.com/fastly/231944713338ee052c2915fd95e1b284a0d7d01809440b4b2f67d53b1a413cb5.jpeg",
    "https://cdn.faire.com/fastly/d903d6f95d7a72b0c9a22f078e8231a7a63959703315b1145ce4086bd83ddafa.jpeg",
    "https://cdn.faire.com/fastly/217f7eaeb2373414e7a0f53681de71dc9c6dab271e139653c9679012d68dd056.jpeg"
  ],
  priceDollars: 111.6,
  description: "A grid that shifts as you look at it, borrowed from the op art of Bridget Riley. Double knit means two faces worked as one — that is where the warmth comes from, without the stiffness.\n\n * 100% Merino Wool \n * Artisan made in Peru with Fair Trade practices to maintain ethical and responsible integrity \n * Relaxed and straight through the body, in a v-neck ",
  tags: [],
  msrpDollars: 248,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T05:50:30.574Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
